<template>
    <!-- Main Wrapper -->
        <div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Sidebar -->
                <layout-sidebar />
			<!-- /Sidebar -->
			
			<!-- Page Wrapper -->
            <div class="page-wrapper">
			
				<!-- Page Content -->
                <div class="content container-fluid">
					
					<!-- Page Header -->
					<div class="page-header">
						<div class="row">
							<div class="col-sm-12">
								<h3 class="page-title">Offered Jobs</h3>
								<ul class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Dashboard</router-link></li>
									<li class="breadcrumb-item ">Jobs</li>
									<li class="breadcrumb-item ">User Dashboard</li>
									<li class="breadcrumb-item active">Offered Jobs</li>
								</ul>
							</div>
						</div>
					</div>
					<!-- /Page Header -->
					
					<!-- Content Starts -->
					<div class="card">
						<div class="card-body">
							<ul class="nav nav-tabs nav-tabs-solid nav-justified">
								<li class="nav-item"><router-link class="nav-link
                                
                                
                                
                                " to="/user-dashboard">Dashboard</router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/user-all-jobs">All </router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/saved-jobs">Saved</router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/applied-jobs">Applied</router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/interviewing">Interviewing</router-link></li>
								<li class="nav-item"><router-link class="nav-link active" to="/offered-jobs">Offered</router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/visited-jobs">Visitied </router-link></li>
								<li class="nav-item"><router-link class="nav-link" to="/archived-jobs">Archived </router-link></li>
							</ul>
						</div>
					</div>	
					
					<!-- Search Filter -->
					<div class="row filter-row">
						<div class="col-sm-6 col-md-3">  
							<div class="form-group form-focus select-focus">
								<select class="select floating"> 
									<option>Select</option>
									<option>Development</option>
									<option>Designing</option>
									<option>Android</option>
								</select>
								<label class="focus-label">Department</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3">  
							<div class="form-group form-focus select-focus">
								<select class="select floating"> 
									<option>Select</option>
									<option>Full Time</option>
									<option>Part Time</option>
									<option>Internship</option>
								</select>
								<label class="focus-label">Job Type</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3"> 
							<div class="form-group form-focus select-focus">
								<select class="select floating"> 
									<option>Select Designation</option>
									<option>Web Developer</option>
									<option>Web Designer</option>
									<option>Android Developer</option>
									<option>Ios Developer</option>
								</select>
								<label class="focus-label">Designation</label>
							</div>
						</div>
						<div class="col-sm-6 col-md-3">  
							<a  class="btn btn-success btn-block"> Search </a>  
						</div>
                    </div>
					<!-- Search Filter -->

					<div class="row">
						<div class="col-md-12">
							<div class="table-responsive">
								<table class="table table-striped custom-table mb-0 datatable">
									<thead>
										<tr>
											<th>#</th>
											<th>Job Title</th>
											<th>Department</th>
											<th class="text-center">Job Type</th>
											<th class="text-center">Actions</th>
											
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>1</td>
											<td><router-link to="/jobdetails">Web Developer</router-link></td>
											<td>Development</td>
											<td class="text-center">
												<div class="action-label">
													<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
														<i class="fa fa-dot-circle-o text-danger"></i> Full Time
													</a>
												</div>
											</td>
											<td class="text-center">
												<a href="#" class="btn btn-sm btn-info download-offer"><span><i class="fa fa-download mr-1"></i> Download Offer</span></a>
											</td>
										</tr>
										<tr>
											<td>2</td>
											<td><router-link to="/jobdetails">Web Designer</router-link></td>
											<td>Designing</td>
											<td class="text-center">
												<div class="action-label">
													<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
														<i class="fa fa-dot-circle-o text-success"></i> Part Time
													</a>
												</div>
											</td>
											<td class="text-center">
												<a href="#" class="btn btn-sm btn-info download-offer"><span><i class="fa fa-download mr-1"></i> Download Offer</span></a>
											</td>
										</tr>
										<tr>
											<td>3</td>
											<td><router-link to="/jobdetails">Android Developer</router-link></td>
											<td>Android</td>
											<td class="text-center">
												<div class="action-label">
													<a class="btn btn-white btn-sm btn-rounded" href="#" data-toggle="dropdown" aria-expanded="false">
														<i class="fa fa-dot-circle-o text-danger"></i> Internship
													</a>
												</div>
											</td>
											<td class="text-center">
												<a href="#" class="btn btn-sm btn-info download-offer"><span><i class="fa fa-download mr-1"></i> Download Offer</span></a>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				
					<!-- /Content End -->
					
                </div>
				<!-- /Page Content -->
				
            </div>
			<!-- /Page Wrapper -->
			
        </div>
		<!-- /Main Wrapper -->
</template>

<script>
    export default {
        mounted() {
            // Select 2
            if ($('.select').length > 0) {
                $('.select').select2({
                    minimumResultsForSearch: -1,
                    width: '100%'
                });
            }
        },
        name: 'taskreports'
    }
</script>


// WEBPACK FOOTER //
// src/components/offeredjobs.vue